import { PositionedContainer } from '../../../../components'
import styled from 'styled-components'

const PositionedContainerStyled = styled(PositionedContainer)`
  top: var(--use-of-type-top);
  left: var(--use-of-type-left);
`

export default PositionedContainerStyled
